import {
    useMemo, useState,
} from 'react'
import noop from 'lodash/noop'

import {
    dateMask,
    dateToStr,
} from 'app/utils/date'
import useLabel from 'app/hooks/useLabel'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import useLoadDtoForSkyNetTable from 'app/shared-components/SkyNetTable/hooks/useLoadDtoForSkyNetTable'
import Card from 'app/shared-components/Card'
import useTableStyles from 'app/tss/table.styles'
import useCardForTableStyles from 'app/tss/cardForTable'
import requestConfig from 'app/requests/LongTermLease/BookedContainer.requests'
import DateRangeSelector from 'app/shared-components/DateRangeSelector/DateRangeSelectorContainer'

import {
    ContainerUsage,
} from '../../longTermLease.types'
import getColumns from './containersUsageTable.columns'
import useStyles from './containersUsageTable.styles'

const ContainersUsageTable = ({
    longTermLeaseId,
}: { longTermLeaseId: number }) => {
    const l = useLabel()
    const {
        classes,
        cx,
    } = useStyles()
    const {
        classes: tableClasses,
    } = useTableStyles()
    const {
        classes: cardClasses,
    } = useCardForTableStyles()

    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()

    const [
        dateRange,
        setDateRange,
    ] = useState({
        to: null,
        from: null,
    })

    const columns = useMemo(() => {
        return getColumns({
            l,
            containerLinkConfig: {
                path: ContainersRoutes.Overview.path,
                params: {
                    key: 'containerSerialNumber',
                },
            },
        })
    }, []) // eslint-disable-line

    const urlConfig = useMemo(() => {
        const url = requestConfig.containerUsage({
            longTermLeaseId,
        })

        return {
            customUrl: url.url,
            method: url.method,
            name: 'ContainersUsage',
            filters: dateRange.from && dateRange.to ? {
                validFrom: dateRange.from ? dateToStr(dateRange.from, dateMask) : undefined,
                validTo: dateRange.to ? dateToStr(dateRange.to, dateMask) : undefined,
            } : undefined,
        }
    }, [
        dateRange.from,
        dateRange.to,
        longTermLeaseId,
    ])

    const load: (params: any) => Promise<{
        items: ContainerUsage,
        matches: number
    }> = useLoadDtoForSkyNetTable(urlConfig)

    return (
        <Card
            title="Containers Usage"
            className={cardClasses.root}
        >
            <DateRangeSelector
                mini
                showTimeRange
                setDateRange={noop}
                onChange={setDateRange}
                value={dateRange}
            />
            <RichTable
                configName="ContainersUsageTable"
                name="ContainersUsage"
                load={load}
                columns={columns}
                className={cx(tableClasses.tableContent, classes.table)}
                classNames={{
                    contentWrapper: tableClasses.tableContentWrapper,
                }}
                uniqField="id"
            />
        </Card>
    )
}

export default ContainersUsageTable
